export { default } from './SkeletonLightMonthlyHistogram';
